import { Divider } from "antd";
import React from "react";

function Settings() {
  return (
    <div>
      <div className="text-heading20 mb-[22px]">Settings</div>
      <Divider />
      <div className="text-center pt-2">
        <div className="text-xl">No settings available!</div>
        <div className="opacity-90">
          It looks like there are no settings to configure at the moment.
        </div>
      </div>
    </div>
  );
}

export default Settings;
